import { mutations } from './mutations';

export default {
    namespaced: true,
    
    state: () => ({
        selectedFmk: null,
        selections: {
            year: null,
            make: null,
            model: null,
            style: null
        },
        options: {
            years: [],
            makes: [],
            models: [],
            styles: []
        },
        selected: {
            year: '',
            make: {
                makename: ''
            },

            model: {
                modelname: ''
            },
            style: {
                stylename: ''
            },
           
        }
    }),
    getters: {
        getVehicle: state => state.selected,
        getMake: state =>state.selected.make.makename,
        getModel: state =>state.selected.model.modelname,
        getYear: state =>state.selected.year,
        getStyle: state =>state.selected.style.stylename,
    },
    
    mutations
};